import { useEffect, useState } from 'react';
import api from '../../services/api';
import EmployerLayout from '../../layouts/EmployerLayout';
import Button from '../../components/common/Button';
import Badge from '../../components/common/Badge';

export default function SavedWorkers() {
  const [workers, setWorkers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    api.get(`/employer/workers/saved?page=${page}&limit=12`)
      .then((r) => { setWorkers(r.data.data || []); setPagination(r.data.pagination || {}); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <EmployerLayout>
      <div className="space-y-5">
        <h1 className="text-xl font-bold text-gray-900">Saved Workers</h1>

        {loading ? (
          <div className="flex justify-center py-16">
            <div className="animate-spin h-8 w-8 border-4 border-india border-t-transparent rounded-full" />
          </div>
        ) : workers.length === 0 ? (
          <div className="text-center py-16 bg-white rounded-xl border border-gray-200">
            <span className="text-4xl">⭐</span>
            <p className="text-gray-500 mt-3">No saved workers yet</p>
            <p className="text-sm text-gray-400 mt-1">Save workers from the search page to find them quickly</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {workers.map((w) => (
              <div key={w.id} className="bg-white rounded-xl border border-gray-200 p-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center font-bold text-gray-500 flex-shrink-0">
                    {w.full_name?.[0]?.toUpperCase() || '?'}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="font-semibold text-gray-900 text-sm">{w.full_name}</h3>
                      <Badge label={w.verification_status} variant={w.verification_status} />
                    </div>
                    <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1 text-xs text-gray-500">
                      {w.experience_years > 0 && <span>⏳ {w.experience_years} yrs exp</span>}
                      {w.daily_wage_min && <span>💰 ₹{w.daily_wage_min}/day</span>}
                    </div>
                    <Badge label={w.availability_status} variant={w.availability_status} />
                    {w.note && <p className="text-xs text-gray-400 mt-1.5 italic">"{w.note}"</p>}
                    {w.list_name && w.list_name !== 'Default' && (
                      <p className="text-xs text-gray-400 mt-0.5">List: {w.list_name}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {pagination.totalPages > 1 && (
          <div className="flex justify-center gap-3">
            {pagination.hasPrev && (
              <Button size="sm" variant="secondary" onClick={() => setPage((p) => p - 1)}>← Prev</Button>
            )}
            <span className="text-sm text-gray-500 py-1.5">Page {pagination.page} of {pagination.totalPages}</span>
            {pagination.hasNext && (
              <Button size="sm" variant="secondary" onClick={() => setPage((p) => p + 1)}>Next →</Button>
            )}
          </div>
        )}
      </div>
    </EmployerLayout>
  );
}
